var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonLeftTopreact = function SvgButtonLeftTopreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 164.188 164.463"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1896"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 4",
    d: "M85.08 49.797 60.648 106.39 4.514 82.156a74.184 74.184 0 0 1 14.718-19.881C32.039 49.895 53.533 38.33 85.08 49.797Zm51.938 66.373L80.882 91.937l24.433-56.593c53.459 26.91 31.703 80.826 31.703 80.826Z",
    fill: "#ffc200",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 0.99999
  }))));
};

export default SvgButtonLeftTopreact;